<template>
  <div class="hpWebinars">
    <span class="hpSecTitle" style="__color:#fff;">
      {{localize('online_webinars')}}
    </span>
    <div class="hpSecSub">
      <router-link :to="getMainPageLink">
        {{localize('browse_webinars')}} - <span>{{localize('view_all')}}</span>
      </router-link>
    </div>
    <hp-accordion :children="sectionData.items"></hp-accordion>
    <!-- <hp-accordion :children="acorData"></hp-accordion>     -->

<!--     <a class="hpWebinarsLink hpFont1 text-blue-6">
      <span style="font-weight:400 !important;">More Webinars</span>
    </a>
 -->    
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import hpAccordion from "./comp/hpAccordion.vue";

export default {
components: { hpAccordion },
  props: {
    sectionData:{}
  },
  data() {
    return {
        acorData:
        [
          {
            "title":"The Challenging Anterior Transition Zone Between Teeth and Implant",
            "subtitle":"Dr. Victor Clavijo",
            "url":"http://www.dtstudyclub.com/webinar/the-restoration-soft-tissue-interface-around-teeth-and-implants-concept-and-implementation/",
            "__img":"https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Victor_Clavijo.jpg",
            "img":"img/_temp/Victor_Clavijo.png"
          },
          {
            "title":"The implant abutment complex in the esthetic zone New perspectives",
            "subtitle":"Dr. Stavros Pelekanos",
            "url":"http://www.dtstudyclub.com/webinar/the-restoration-soft-tissue-interface-around-teeth-and-implants-concept-and-implementation/",
            "__img":"https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Stavros_Pelekanos.jpg",
            "img":"img/_temp/Stavros_Pelekanos.png"
          },
          {
            "title":"The Restoration Soft tissue interface around teeth and implants: Concept and Implementation",
            "subtitle":"Dr. Mirela Feraru",
            "url":"http://www.dtstudyclub.com/webinar/the-restoration-soft-tissue-interface-around-teeth-and-implants-concept-and-implementation/",
            "img":"https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Mirela_Feraru.jpg",
            "img":"img/_temp/Mirela_Feraru.png"
          },
          {
            "title":"Guided Surgery in Aesthetic Zone - The System Predictability",
            "subtitle":"Dr. Gustavo Giordani | 1CE",
            "url":"http://www.dtstudyclub.com/webinar/the-restoration-soft-tissue-interface-around-teeth-and-implants-concept-and-implementation/",
            "__img":"https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Gustavo_Giordani.jpg",
            "img":"img/_temp/Gustavo_Giordani.png"
          },
          {
            "title":"Understanding Implant Biology for the Surgical and Restorative Dentist: Limiting Bone Loss",
            "subtitle":"Dr. Kyle Stanley | 1CE",
            "url":"http://www.dtstudyclub.com/webinar/the-restoration-soft-tissue-interface-around-teeth-and-implants-concept-and-implementation/",
            "__img":"https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Kyle_Stanley.jpg",
            "img":"img/_temp/Kyle_Stanley.png"
          },
        ]
    };
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    ...mapGetters(["localeString"]),
    getMainPageLink()
    {
      return this.parsedLocaleString+"/education/mis-academy/online-webinars";
    },    
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    }

  },
  methods: {
  }
};
</script>

<style scoped>
  .hpWebinars
  {
    padding: 2vw 10vw 2vw 10vw;
    padding-left: 10vw;
    padding-right: 10vw;
    height: auto;
    min-height: 600px;
    /* padding-bottom: 100px; */
  }
  .hpWebinarsLink
  {
      float: right;
      cursor: pointer;
  }
  .hpWebinarsLink:hover span
  {
    color:#fff;
  }  

    @media screen and (max-width: 815px) {
        .hpWebinars
        {
          padding-left: 0px;
          padding-right: 0px;
          padding-top: 14vw !important;
        }

    }  
</style>
